// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"587":"9b56c8d882787ba7","770":"80f0458fff287f03"}[chunkId] + ".js";
};